import styled from '../../../../../theme/styled';

const InfoPrice = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  display: flex;
  flex-direction: column;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  padding-top: ${({ theme }) => theme.space[4]};
`;

export default { InfoPrice };
